// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605070757/js/" + chunkId + "." + {"44":"eae4e666","225":"f44831c3","481":"88e3cd4b","486":"47334cf9","770":"74f9077f"}[chunkId] + ".0.4858433749796307.chunk.js";
};